// 普通商品列表 API

import {apiFactory, addSearchParamsPrefix} from '../index'
const api = apiFactory('servicemart')

/**
 * 列表查询
 * @param params
 * @param sort
 * @param page
 * @returns {*|PromiseLike<T | never>|Promise<T | never>}
 */
export function pageStoreInfo({params = {}, page = {}} = {}) {
  return api.get('/storeInfo/pageStoreInfo', {
    params: {
      ...addSearchParamsPrefix(params),
      ...page,
    },
  }).then(res => res.data)
}
/**
 * 站内信列表查询
 * @param params
 * @param sort
 * @param page
 * @returns {*|PromiseLike<T | never>|Promise<T | never>}
 */
export function pageMessage({params = {}, page = {}} = {}) {
  return api.get('/message/pageMessage', {
    params: {
      ...addSearchParamsPrefix(params),
      ...page,
    },
  }).then(res => res.data)
}

/**
 * 站内信已读
 * @param params
 */
export function readMessage(id) {
  return api.post(`/message/readMessage/${id}`).then(res => res.data)
}
/**
 * 是否含有未读站内信
 * @param params
 */
export function haveNeverRead() {
  return api.get(`/message/haveNeverRead`).then(res => res.data)
}

/**
 * 审核通过
 * @param params
 */
export function passCheck(id) {
  return api.post(`/storeInfo/passCheck`, id).then(res => res.data)
}

/**
 * 审核不通过
 * @param params
 */
export function failCheck(id) {
  return api.post(`/storeInfo/failCheck`, id).then(res => res.data)
}
/**
 * 再次申请审核
 * @param params
 */
export function waitCheck(id) {
  return api.post(`/storeInfo/waitCheck/${id}`).then(res => res.data)
}

/**
 * 年费列表
 * @param params
 * @param sort
 * @param page
 * @returns {*|PromiseLike<T | never>|Promise<T | never>}
 */
export function pageAnnualFee({params = {}, page = {}} = {}) {
  return api.get('/annualFee/pageAnnualFee', {
    params: {
      ...addSearchParamsPrefix(params),
      ...page,
    },
  }).then(res => res.data)
}

/**
 * 新增年费标准
 * @param user
 * @returns {*|PromiseLike<T | never>|Promise<T | never>}
 */
export function addAnnualFee(newfee) {
  return api.post('/annualFee/addAnnualFee', newfee).then(res => res.data)
}

/**
 * 获取年费详情
 * @param id
 * @returns {*}
 */
export function annualFeeById(id) {
  return api.get(`/annualFee/annualFeeById/${id}`).then(res => res.data)
}

/**
 * 删除年费信息
 * @param id
 * @returns {*}
 */
export function deleteAnnualFee(id) {
  return api.delete(`/annualFee/deleteAnnualFee/${id}`).then(res => res.data)
}

/**
 * 编辑年费标准信息
 * @param params
 */
export function updateStoreInfo(id) {
  return api.post(`/annualFee/updateAnnualFee`, id).then(res => res.data)
}

/**
 * 年费缴纳列表
 * @param params
 * @param sort
 * @param page
 * @returns {*|PromiseLike<T | never>|Promise<T | never>}
 */
export function pageStorePayFee({params = {}, page = {}} = {}) {
  return api.get('/storePayFee/pageStorePayFee', {
    params: {
      ...addSearchParamsPrefix(params),
      ...page,
    },
  }).then(res => res.data)
}

/**
 * 缴纳年费金额
 * @param params
 */
export function updateStorePayFee(data) {
  return api.post(`/storePayFee/updateStorePayFee`, data).then(res => res.data)
}

/**
 * 缴纳年费
 * @param params
 */
export function payFee(data) {
  return api.post(`/storePayFee/payFee`, data).then(res => res.data)
}

/**
 * 获取缴纳年费金额详情
 * @param id
 * @returns {*}
 */
export function storePayFeeById(id) {
  return api.get(`/storePayFee/storePayFeeById?id=${id}`).then(res => res.data)
}
